<header class="top-header">
  <svg-icon
    class="logo"
    role="img"
    [attr.aria-label]="productName"
    [src]="(themeService.theme$ | async)?.onBackgroundIconUrl"></svg-icon>
  <div class="header-nav">
    <a routerLink="/login" class="login-link">Sign In</a>
    <button
      class="button button-pill button-primary get-started"
      data-test="get-started-header-button"
      *ngIf="!isLoading"
      (click)="getStartedClicked.emit('banner')">
      Get Started
    </button>
  </div>
</header>
